import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import logo from '../../../images/logo2.svg';
import { createUser } from '../../../redux/actions/auth/AuthActions';
import dummyUser from '../../../models/User';

const Signup = ({ createUser, authUser, history }) => {
    const [user, setUser] = useState(dummyUser);
    // const [showToast, setShowToast] = useState(false);

    const location = useLocation();
    const redirectPath = location.state?.from || '/';

    const handleRegister = (e) => {
        e.preventDefault();
        // const randomNum = Math.floor((Math.random() * 1000) + 1);
        // setUser({
        //     ...user, username: user.username+randomNum
        // });
        createUser(user);
        // .then(() => {
        //     if (authUser.length === 0) {
        //         toast.error('Username already exists!', 2000);
        //     } else {
        //         setUser(authUser);
        //         localStorage.setItem('user', authUser);
        //         localStorage.setItem('isLoggedIn', false);
        //     }
        // });
    };

    useEffect(() => {
        toast.info('Welcome to signup page!');
    }, []);

    useEffect(() => {
        // if(authUser) {
        //     console.log(authUser);
        //     setUser(authUser);
        //     localStorage.setItem('user', authUser);
        // }
        console.log('authUser', authUser);
        if (authUser && authUser.length > 0 && Object.keys(authUser[0]).length === 0) {
            toast.error('Username already exists!');
        } else {
            if(authUser.length > 0) {
                setUser(authUser);
                const existingUsers = JSON.parse(localStorage.getItem('users')) || [];
                existingUsers.push(authUser);
                localStorage.setItem('users', JSON.stringify(existingUsers));
                localStorage.setItem('isLoggedIn', 'false');
                history.push({
                    pathname: '/auth/login',
                    state: { from: redirectPath}
                });
            }
        }
    }, [authUser]);
    
    return(
        <div>
            <section className="container-fluid maindiv mt-4">
                <div className="container formdiv d-flex shadow">
                    <img src={logo} className="formimg"></img>
                    <form className="myform" onSubmit={handleRegister} >
                        <div className="form-group mt-2">
                            <label htmlFor="exampleUserName">User Name</label>
                            <input value={user.username} onChange={(e) => setUser({...user, username: e.target.value})} type="text" className="form-control" id="exampleUserName" required/>
                        </div>
                        <div className="form-group mt-2">
                            <label htmlFor="examplePassword">Password</label>
                            <input value={user.password} onChange={(e) => setUser({ ...user, password: e.target.value })} type="password" className="form-control" id="examplePassword" required/>
                        </div>
                        <div className="form-group mt-2">
                            <label htmlFor="exampleRePassword">Re-enter password</label>
                            <input value={user.password} type="password" className="form-control" id="exampleRePassword" required/>
                        </div>
                        
                        {/* <div className="form-group mt-2">
                            <label htmlFor="exampleInputEmail1">Email address</label>
                            <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"/>
                        </div>
                        <div className="form-group mt-2">
                            <label htmlFor="exampleInputPassword1">Password</label>
                            <input type="password" className="form-control" id="exampleInputPassword1"/>
                        </div> */}
                        <button type="submit" className="btn btn-primary mt-2">Register</button>
                        <p className="mt-2"><span><Link to="/auth/login"> LogIn Here </Link></span></p>
                    </form>
                    {/* {showToast ? (
                        <div className="toast" role="alert" aria-live="assertive" aria-atomic="true">
                            <div className="toast-header">
                                <strong className="mr-auto">Bootstrap</strong>
                                <small className="text-muted">11 mins ago</small>
                                <button type="button" className="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="toast-body">
                                Hello, world! This is a toast message.
                            </div>
                        </div>
                    ) : null} */}
                </div>
            </section>
            <ToastContainer />
        </div>
    );
};


Signup.propTypes = {
    authUser: PropTypes.object.isRequired,
    createUser: PropTypes.func.isRequired
};

Signup.defaultProps = {
    authUser: {}
};

const mapStateToProps = (state) => {
    console.log('state', state);
    return {
        authUser: state.auths,
    };
};

const mapDispatchToProps = {
    createUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(Signup);